export const concatStrings = (...strs: unknown[]) => strs.filter(Boolean).join(' ');
